import { useProjectTakenActions } from "@/organisms/Drawers/components/TriageDrawer/components/TakenActions"
import { TakenActionsCell } from "./TakenActionsCell"

// Holds the hook itself: antd calls a column's render as a plain function.
export const ProjectTakenActionsCell = ({
  projectId
}: {
  projectId?: string
}) => {
  const actions = useProjectTakenActions(projectId)

  return <TakenActionsCell actions={actions} />
}

export const renderProjectTakenActions = (
  _: string,
  record: { id: string }
) => <ProjectTakenActionsCell projectId={record.id} />
